import React from 'react';

import { useGetPoolMaintenanceDetails } from './utils/useGetPoolMaintenanceDetails';
import { convertToNumber } from 'utils/converters';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { LoadingError } from 'components/shared/LoadingError/LoadingError';
import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

import { CreateEditPoolMaintenanceForm } from './CreateEditPoolMaintenanceForm';

export const PoolMaintenanceLoaderFeedback: React.FC<FormComponentProps> = ({
  handleClose,
  rowId
}) => {
  const { isFetching, data, error, refetch } = useGetPoolMaintenanceDetails(
    convertToNumber(rowId)
  );

  return isFetching ? (
    <SectionSkeleton />
  ) : error ? (
    <LoadingError reFetch={refetch} />
  ) : (
    <CreateEditPoolMaintenanceForm handleClose={handleClose} rowData={data} />
  );
};
